const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  platformConfig: state => state.config.platformConfig,
  appConfig: state => state.config.appConfig,
  init: state => state.config.init,
  menuList: state => state.config.menuList,
  isRecharge: state => state.config.isRecharge,
  serverDataInfo: state => state.config.serverDataInfo,
  versionInfo: state => state.user.versionInfo,
  independentPay: state => state.user.independentPay,
  foreignCityList: state => state.user.foreignCityList,
  ownSwitch: state => state.user.ownSwitch,
  globeCityList: state => state.config.globeCityList,
  authorizedUserName: state => state.user.authorizedUserName,
  sortCount: state => state.user.sortCount,
  sortDrawn: state => state.user.sortDrawn,
  sortCash: state => state.user.sortCash,
  h5DomainUrl: state => state.user.h5DomainUrl,
  systemService: state => state.user.systemService,
  merchantField: state => state.user.merchantField
}

export default getters
